import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC5hUnW9w9Ao5DFf15M9JU7QZyHGjEe72g",
  authDomain: "login-5b486.firebaseapp.com",
  projectId: "login-5b486",
  storageBucket: "login-5b486.firebasestorage.app",
  messagingSenderId: "409772681483",
  appId: "1:409772681483:web:42554cf8bcf53c52341a0e"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
